import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';

const AdminDashboard: React.FC = () => {
  const { user } = useUser();

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Welcome Section */}
      <section style={{ marginBottom: '40px' }}>
        <h1>Admin Dashboard</h1>
        <p style={{ fontSize: '18px', color: '#666' }}>
          Welcome back, {user?.fullName || 'Admin'}! Manage your webshop operations from here.
        </p>
      </section>

      {/* Navigation Cards */}
      <section>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
          {/* Order Overview Card */}
          <Link
            to="/admin/orders"
            style={{
              textDecoration: 'none',
              padding: '30px',
              backgroundColor: '#007bff',
              color: 'white',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📦</div>
            <h2 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>Order Overview</h2>
            <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>
              View and manage all customer orders, filter by pickup date and payment status
            </p>
          </Link>

          {/* Pickup Locations Card */}
          <Link
            to="/admin/locations"
            style={{
              textDecoration: 'none',
              padding: '30px',
              backgroundColor: '#17a2b8',
              color: 'white',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📍</div>
            <h2 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>Pickup Locations</h2>
            <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>
              Manage pickup locations where customers can collect their orders
            </p>
          </Link>

          {/* Pickup Dates Card */}
          <Link
            to="/admin/pickups"
            style={{
              textDecoration: 'none',
              padding: '30px',
              backgroundColor: '#28a745',
              color: 'white',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📅</div>
            <h2 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>Pickup Dates</h2>
            <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>
              Schedule pickup dates and set inventory limits for each location
            </p>
          </Link>

          {/* Product Management Card */}
          <Link
            to="/admin/products"
            style={{
              textDecoration: 'none',
              padding: '30px',
              backgroundColor: '#ffc107',
              color: '#333',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
            }}
          >
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>🦞</div>
            <h2 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>Product Management</h2>
            <p style={{ margin: 0, fontSize: '16px', opacity: 0.9 }}>
              Add, edit, and manage seafood products in your catalog
            </p>
          </Link>
        </div>
      </section>

      {/* Quick Stats Section (Optional Enhancement) */}
      <section style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
        <h3 style={{ marginTop: 0 }}>Quick Actions</h3>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
          <Link
            to="/admin/orders"
            style={{
              padding: '10px 20px',
              backgroundColor: 'white',
              color: '#007bff',
              textDecoration: 'none',
              borderRadius: '4px',
              border: '1px solid #007bff',
              fontWeight: 'bold',
            }}
          >
            View Recent Orders
          </Link>
          <Link
            to="/admin/locations"
            style={{
              padding: '10px 20px',
              backgroundColor: 'white',
              color: '#17a2b8',
              textDecoration: 'none',
              borderRadius: '4px',
              border: '1px solid #17a2b8',
              fontWeight: 'bold',
            }}
          >
            Manage Locations
          </Link>
          <Link
            to="/admin/pickups"
            style={{
              padding: '10px 20px',
              backgroundColor: 'white',
              color: '#28a745',
              textDecoration: 'none',
              borderRadius: '4px',
              border: '1px solid #28a745',
              fontWeight: 'bold',
            }}
          >
            Add Pickup Date
          </Link>
          <Link
            to="/admin/products"
            style={{
              padding: '10px 20px',
              backgroundColor: 'white',
              color: '#ffc107',
              textDecoration: 'none',
              borderRadius: '4px',
              border: '1px solid #ffc107',
              fontWeight: 'bold',
            }}
          >
            Add Product
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
